import {CustomEventTypes} from "../UniversalType.js";
export var InputState;
(function(InputState2) {
  InputState2[InputState2["MouseDown"] = 0] = "MouseDown";
  InputState2[InputState2["MouseDrag"] = 1] = "MouseDrag";
  InputState2[InputState2["MouseUp"] = 2] = "MouseUp";
  InputState2[InputState2["MouseMove"] = 3] = "MouseMove";
})(InputState || (InputState = {}));
class InputHandler {
  constructor(webglCanvas, eventSystem) {
    this._delayEvent = 10;
    this._lastEventTime = 0;
    this._webglCanvas = webglCanvas;
    this.eventSystem = eventSystem;
    window.addEventListener("mousedown", this.OnMouseDown.bind(this));
    window.addEventListener("mouseup", this.OnMouseUp.bind(this));
    window.addEventListener("mousemove", this.OnMouseMove.bind(this));
    window.addEventListener("touchstart", this.OnMouseDown.bind(this), false);
    window.addEventListener("touchend", this.OnMouseUp.bind(this), false);
  }
  OnMouseDown(e) {
    this._startMousePosition = this.GetMousePosVector(e);
    this._isMouseDown = true;
    this.eventSystem.Notify(CustomEventTypes.MouseDownEvent, {mousePosition: this._startMousePosition});
  }
  OnMouseMove(e) {
    let mousePos = this.GetMousePosVector(e);
    this.eventSystem.Notify(CustomEventTypes.MouseMoveEvent, {mousePosition: mousePos});
    if (!this._isMouseDown)
      return;
    if (e.timeStamp < this._lastEventTime)
      return;
    this.eventSystem.Notify(CustomEventTypes.MouseDragEvent, {mousePosition: mousePos});
    this._lastEventTime = e.timeStamp + this._delayEvent;
  }
  OnMouseUp(e) {
    this._isMouseDown = false;
    this.eventSystem.Notify(CustomEventTypes.MouseUpEvent, {mousePosition: this.GetMousePosVector(e)});
  }
  GetMousePosVector(e) {
    let clickYPos = this._webglCanvas.clientHeight - e.y;
    let clickXPos = e.x;
    return {x: clickXPos, y: clickYPos};
  }
}
export default InputHandler;
